import { yupArray, YupSchema } from 'services/yup'
import { mainProductSelectionVS } from './mainProduct'
import { upsellingSelectionVS } from '../upselling'
import { MainProductWithUpsellingSelection } from 'services/api/entities/events/types/internal/selections'

export const mainProductWithUpsellingSelectionVS: YupSchema<MainProductWithUpsellingSelection> =
  mainProductSelectionVS.shape({
    upsellingSelection: yupArray(upsellingSelectionVS),
  })
